import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

/**
 * Convert UTC timestamp → Local browser time (global)
 * Format: 29.04.2026, 9:20 am
 */
export const formatDateTime = (time) => {
  if (!time) return "";

  return dayjs.utc(time).local().format("DD.MM.YYYY, h:mm a");
};

/**
 * Only date
 * Format: 29.04.2026
 */
export const formatDate = (time) => {
  if (!time) return "";

  return dayjs.utc(time).local().format("DD.MM.YYYY");
};

/**
 * Only time
 * Format: 9:20 am
 */
export const formatTime = (time) => {
  if (!time) return "";

  return dayjs.utc(time).local().format("h:mm a");
};
